'use strict'
import $ from 'jquery'
export default class Tabs{
  constructor(el) {
    this.$el = $(el)
    this.$items = this.$el.find('.rolodex__item').toArray()
    this.$index = 1
    const that = this

    if (this.$items.length > 1) {
      $(this.$items[0]).addClass('slide-in')
      setInterval(function () {
        that.$item = that.$items[that.$index]
        that.$activeIndex = that.$index - 1      
        if (that.$activeIndex === -1) {
          that.$activeIndex = that.$items.length - 1
        }
        $(that.$items[that.$activeIndex]).addClass('slide-out').siblings('.slide-out').removeClass('slide-out').addClass('invisible')
        $(that.$item).removeClass('invisible').addClass('slide-in').siblings('.slide-in').removeClass('slide-in')
        if (that.$index === (that.$items.length - 1)) {
          that.$index = 0
        } else {
          that.$index++
        }
      }, 6000)
    }
  }
}
